// @ts-ignore
import { isClient, isInEsignApp } from './utils'
import tsignData from '@tsign/tsigndata-sdk-js-for-statistics'
// 使用埋点工具代理神策 tsignData 不需要进行操作，是因为@tsign/tsigndata-sdk-js-for-statistics包中在0.0.2版本中放入工具，直接升级包即可

let mode = 'development'
if (process.env.VUE_APP_MODE === 'prod') {
  mode = 'production'
}
if (process.env.VUE_APP_MODE === 'sml') {
  mode = 'preparation'
}


tsignData.init({
  mode, // 生产环境需配置为production
  // eslint-disable-next-line camelcase
  use_app_track: false,
  // eslint-disable-next-line camelcase
  show_log: mode !== 'production',
  preset_properties: { //是否采集 $latest_landing_page 最近一次落地页地址，默认值 false。需要版本在1.14.24 及以上版本，本次使用的是1.14.11版本
    latest_landing_page: true,
  },
})

tsignData.registerPage({
  PlatformType: isInEsignApp() ? 'esignAPP' : isClient() ? 'H5' : 'WEB',
})
// --------------------------神策配置结束------------------------------

export default tsignData
